import { useQuery } from '@tanstack/react-query';
import { fileMakerAPI } from '../api/users.api';
import type { FMExpert, FMCustomer } from '../types';

export const useExpertsList = () => {
  return useQuery({
    queryKey: ['fm-experts'],
    queryFn: async () => {
      const response = await fileMakerAPI.getExpertsList();
      // Response is { success, data: { total_experts, experts } }
      const data = response.data as { experts: FMExpert[]; total_experts: number } | FMExpert[];
      if (Array.isArray(data)) {
        return data;
      }
      return data?.experts ?? [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false
  });
};

export const useCustomerSearch = (searchQuery: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['fm-customers', searchQuery],
    queryFn: async () => {
      const response = await fileMakerAPI.searchCustomers(searchQuery);
      // Response is { success, data: { customers, total } }
      const data = response.data as { customers: FMCustomer[]; total: number } | FMCustomer[];
      if (Array.isArray(data)) {
        return data;
      }
      return data?.customers ?? [];
    },
    enabled: enabled && searchQuery.length >= 2,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};